import { render, staticRenderFns } from "./CreationOrders.vue?vue&type=template&id=55f55f2e&scoped=true&"
import script from "./CreationOrders.vue?vue&type=script&lang=js&"
export * from "./CreationOrders.vue?vue&type=script&lang=js&"
import style0 from "./CreationOrders.vue?vue&type=style&index=0&id=55f55f2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f55f2e",
  null
  
)

component.options.__file = "CreationOrders.vue"
export default component.exports